import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1ebsymwkg7: FaireBrandEntity = {
  token: "b_1ebsymwkg7",
  type: "brand",
  name: "Rising International Inc",
  avatarUrl:
    "https://cdn.faire.com/fastly/d45cb4371a0b02efa0d853c6a33dd7095e417f420fb9b981a8db77a0cbc971b1.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5e84c6fc99483c50352a3e15e8dc4d7835a681ccfd354bacacea546de34e156b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d45cb4371a0b02efa0d853c6a33dd7095e417f420fb9b981a8db77a0cbc971b1.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5e84c6fc99483c50352a3e15e8dc4d7835a681ccfd354bacacea546de34e156b.png",
  location: "Irwindale, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 246,
  isTopShop: true,
  isInsider: true,
  description:
    "Rising International, founded by two brothers from Nepal, specializes in importing Nepalese handmade clothing, handicrafts, and accessories. It's a family business that values its Nepalese heritage and craftsmanship. The company combines Nepalese craftsmanship with modern style, offering unique items that showcase local artisans' talents and support Nepalese communities. Empowering local women artisans is a key part of their mission. They use eco-friendly materials like cotton and hemp, focusing on environmental responsibility. Each product from Rising International tells a story of heritage, skill, and respect for Nepal’s culture. These environmentally conscious items reflect their commitment to sustainable practices. As they grow, they aim to share Nepal's culture worldwide, promoting cultural exchange through their beautiful, eco-friendly products.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:12.433Z",
    importedBy: "entity-db-cli",
  },
};
